// extracted by mini-css-extract-plugin
export default {"headcontainer":"about_headcontainer__F8bs5","hr":"about_hr__xytPQ","card":"about_card__+FrCr"};